import { isNil } from 'lodash';
import { Map3DSidebarOption } from '../components/map-3d-sidebar/shared/enums';

export enum ResourceDeepLinkParam {
  HeapCluster = 'heap_cluster_id',
}

export type ResourceDeepLink = {
  param: ResourceDeepLinkParam;
  id: string;
};

type ResourceDeepLinkConfig = {
  sidebar: Map3DSidebarOption;
  pendingKey: string;
};

const RESOURCE_DEEP_LINKS: Record<
  ResourceDeepLinkParam,
  ResourceDeepLinkConfig
> = {
  [ResourceDeepLinkParam.HeapCluster]: {
    sidebar: Map3DSidebarOption.VolumeCalculation,
    pendingKey: 'pending_heap_cluster_id',
  },
};

export const PendingResourceManager = {
  save: (param: ResourceDeepLinkParam, id: string): void => {
    sessionStorage.setItem(RESOURCE_DEEP_LINKS[param].pendingKey, id);
  },

  get: (param: ResourceDeepLinkParam): string | null => {
    return sessionStorage.getItem(RESOURCE_DEEP_LINKS[param].pendingKey);
  },

  remove: (param: ResourceDeepLinkParam): void => {
    sessionStorage.removeItem(RESOURCE_DEEP_LINKS[param].pendingKey);
  },
};

export const getResourceDeepLinkFromSearchParams = (
  searchParams: URLSearchParams,
): ResourceDeepLink | null => {
  for (const param of Object.values(ResourceDeepLinkParam)) {
    const id = searchParams.get(param);

    if (id) {
      return { param, id };
    }
  }

  return null;
};

export const getResourceDeepLinkSidebar = (
  param: ResourceDeepLinkParam,
): Map3DSidebarOption => {
  return RESOURCE_DEEP_LINKS[param].sidebar;
};

export const requiresHiddenWorkspaceSidebar = (
  link: ResourceDeepLink | null,
): boolean => {
  if (isNil(link)) {
    return false;
  }

  switch (link.param) {
    case ResourceDeepLinkParam.HeapCluster:
      return true;
    default:
      return false;
  }
};
